export default "__VITE_ASSET__CJO98EHY__"